<label for="customRadio">{{ title | translate }}</label>
<div>
   <cdx-radio [canRemoveSelection]="false" [options]="radioYes" (checked)="changeYes($event)"
      [isChecked]="checkedState">
   </cdx-radio>
   <cdx-radio [canRemoveSelection]="false" [options]="radioNo" (checked)="changeNo($event)"
      [isChecked]="!checkedState">
   </cdx-radio>
</div>
